const ContactsIndex = () => 
  import(/* webpackChunkName: 'ContactsIndex' */ '@/Contacts/Index');

// todo cc - remove once we know where to put new contact form
const ContactCreate = () => 
  import(/* webpackChunkName: 'ContactCreate' */ '@/Contacts/Create');
const ContactImportMenu = () => 
  import(/* webpackChunkName: 'ContactImportMenu' */ '@/Contacts/components/import/Menu');
const ContactImportProcess = () => 
  import(/* webpackChunkName: 'ContactImportProcess' */ '@/Contacts/components/import/Index');

const ContactImportProcessReporting = () =>
import(/* webpackChunkName: 'ContactImportProcessReporting' */ '@/Contacts/components/import/Reporting');

// Import contacts module routes
const ContactImportProgress = () => 
  import(/* webpackChunkName: 'ContactImportProgress' */ '@/Contacts/components/import/Progress');
const ContactImportSummary = () => 
  import(/* webpackChunkName: 'ContactImportSummary' */ '@/Contacts/components/import/Summary');
const ContactProfileV2 = () => 
  import(/* webpackChunkName: 'ContactProfileV2' */ '@/Contacts/ProfileV2');
const TransactionDeskCallback = () => import(/* webpackChunkName: 'TransactionDeskCallback' */ '@/Contacts/components/connect/transaction-desk/TransactionDeskCallback');

// Bulk Actions Report
const BulkActionsReport = () =>
  import(/* webpackChunkName: 'BulkActionsReport' */ '@/Contacts/components/bulk-actions-report/BulkActionsReport');

const redirectDirectAccessToImportRoutes = (to, from, next) => {
  if (!from.name && from.path === '/') {
    next('/contacts/import/process');
  } else {
    next();
  }
};

export default [
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsIndex,
    meta: { auth: true },
  },
  {
    path: '/contacts/create',
    name: 'contact-form',
    component: ContactCreate,
    meta: { auth: true },
  },
  {
    path: '/contacts/import/menu',
    name: 'contact-import-menu',
    component: ContactImportMenu,
    meta: { auth: true },
  },
  {
    path: '/contacts/import/process',
    name: 'contact-import-process',
    component: ContactImportProcess,
    meta: { auth: true },
  },
  {
    path: '/contacts/import/reporting',
    name: 'contact-import-reporting',
    component: ContactImportProcessReporting,
    meta: { auth: true },
  },
  {
    path: '/contacts/import/progress',
    name: 'contact-import-progress',
    component: ContactImportProgress,
    meta: { auth: true },
    beforeEnter: redirectDirectAccessToImportRoutes,
  },
  {
    path: '/contacts/import/summary',
    name: 'contact-import-summary',
    component: ContactImportSummary,
    meta: { auth: true },
    beforeEnter: redirectDirectAccessToImportRoutes,
  },
  {
    path: '/contacts/:id',
    name: 'contact-profile',
    component: ContactProfileV2,
    meta: { auth: true },
  },
  {
    path: '/td-callback',
    name: 'td-callback',
    component: TransactionDeskCallback,
    meta: { auth: true },
  },
  {
    path: '/contacts/bulk-actions/:masterId',
    name: 'bulk-actions-report',
    component: BulkActionsReport,
    meta: { auth: true },
  },
];
